import styled, { css } from 'styled-components';

export const Content = styled.div`
  text-align: right;
  padding: 20px;
`;

export const Button = styled.button`
  border: 1px solid #3d4952;
  background: transparent;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 13px;
  letter-spacing: 0.03em;
  margin-left: 10px;
  font-weight: 600;
  color: #aab2b8;
  padding: 9px 18px;
  border-radius: 10px;
  transition: 0.15s all ease-in;
  &:hover {
    border-color: #47b972;
    color: #5cc98a;
  }
`;

export const PrimaryButton = styled(Button)`
  border-color: transparent;
  background: linear-gradient(90deg, #5cc98a 0%, #3aa863 100%);
  color: #ffffff;
  &:hover {
    border-color: transparent;
    color: #ffffff;
    background: linear-gradient(90deg, #3aa863 0%, #2f9457 100%);
  }
`;
